import { produce } from "../../../../../../../libs/immer";
export var closePopupUseCase = function closePopupUseCase(setState) {
  setState(produce(function (prev) {
    prev.isOpen = false;
    prev.statusPopup = undefined;
    prev.scenario = undefined;
  }));
};
export var closeStatusPopupUseCase = function closeStatusPopupUseCase(setState) {
  setState(produce(function (prev) {
    prev.statusPopup = undefined;
  }));
};
export var closeScenarioPopupUseCase = function closeScenarioPopupUseCase(setState) {
  setState(produce(function (prev) {
    prev.scenario = undefined;
    prev.statusPopup = undefined;
  }));
};